export class ShareSocialMedia {
    private element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
        this.init();
    }

    private init(): void {
        this.addEventListeners();
    }

    private addEventListeners(): void {
        const copyBtn = this.element.querySelector<HTMLButtonElement>('#clipboard')!;
        const shareControls = Array.from(
            this.element.querySelectorAll<HTMLElement>('.share-btn')
        );

        copyBtn.addEventListener('click', () => {
            navigator.clipboard.writeText(window.location.href)
                .then(() => {
                    this.announce('Link copied to clipboard');
                })
                .catch(err => console.error('Clipboard copy failed:', err));
        });

        shareControls.forEach(ctrl => this.setupFocusHandling(ctrl));
    }

    private setupFocusHandling(el: HTMLElement): void {
        el.addEventListener('mousedown', () => el.classList.add('mouse-focus'));
        el.addEventListener('mouseup', () => el.classList.remove('mouse-focus'));

        el.addEventListener('focus', () => {
            if (!el.classList.contains('mouse-focus')) {
                el.classList.add('keyboard-focus');
            }
        });

        el.addEventListener('blur', () => {
            el.classList.remove('mouse-focus', 'keyboard-focus');
        });
    }

    private announce(message: string): void {
        let live = document.getElementById('share-live-region') as HTMLDivElement | null;

        if (!live) {
            live = document.createElement('div');
            live.id = 'share-live-region';
            live.className = 'sr-only';
            live.setAttribute('role', 'status');
            live.setAttribute('aria-live', 'polite');
            document.body.appendChild(live);
        }

        live.textContent = message;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('.share-social-media')
        .forEach(el => new ShareSocialMedia(el));
});
